import React from "react";
// import { Camera } from "lucide-react";

const Profile = () => {
    return (
        <div className="p-6">

            {/* Page Header */}
            <div className="mb-6">
                <h1 className="text-3xl font-semibold text-gray-800">
                    Profile
                </h1>
                <p className="text-gray-500 text-sm mt-1">
                    Manage your personal information and account details.
                </p>
            </div>

            {/* Content Card */}
            <div className="bg-white shadow-sm border border-gray-100 rounded-2xl p-6">

                {/* Avatar Section */}
                <div className="flex items-center gap-6 mb-8">
                    <div className="relative">
                        <div className="w-24 h-24 rounded-full bg-gradient-to-r from-indigo-500 to-purple-500 text-white flex items-center justify-center text-3xl font-bold">
                            J
                        </div>
                        {/* <button className="absolute bottom-0 right-0 bg-white shadow-md p-2 rounded-full border border-gray-200 hover:bg-gray-50">
                            <Camera size={16} />
                        </button> */}
                    </div>

                    <div>
                        <h2 className="text-lg font-medium text-gray-800">
                            John Doe
                        </h2>
                        <p className="text-sm text-gray-500">Administrator</p>
                    </div>
                </div>

                {/* Form */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                    <div>
                        <label className="text-sm text-gray-600">Full Name</label>
                        <input
                            type="text"
                            placeholder="John Doe"
                            className="w-full mt-1 px-4 py-3 border border-gray-200 rounded-xl focus:ring-1 focus:ring-black focus:border-black  outline-none"
                        />
                    </div>

                    <div>
                        <label className="text-sm text-gray-600">Email</label>
                        <input
                            type="email"
                            value="john@example.com"
                            disabled
                            className="w-full mt-1 px-4 py-3 border border-gray-200 rounded-xl bg-gray-50"
                        />
                    </div>

                    <div>
                        <label className="text-sm text-gray-600">Phone</label>
                        <input
                            type="text"
                            placeholder="Enter phone number"
                            className="w-full mt-1 px-4 py-3 border border-gray-200 rounded-xl focus:ring-1 focus:ring-black focus:border-black  outline-none"
                        />
                    </div>

                </div>

                {/* Button */}
                <div className="mt-8 flex justify-end">
                    <button className="bg-black text-white px-6 py-3 rounded-xl transition">
                        Save Changes
                    </button>
                </div>

            </div>
        </div>
    );
};

export default Profile;
